module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/payment.5c8d3bfe.png";